import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import logo from '../../images/logo-payway-header.png';

const useStyles =  makeStyles({
    logo: {
        maxHeight: 85
    },
    box: {
        display: 'flex',
        justifyContent: 'center',
    }
});

const Header : React.FC = () => {

    const classes = useStyles();

    return (
        <Grid container >
            <Grid item xs={6} md={12}>
                <Box className={classes.box} mt={3} mb={2}>
                    <img className={classes.logo} src={logo} alt="logo"/>
                </Box>
            </Grid>
        </Grid>
    )
}

export default Header;